import { FC, ReactNode, memo } from 'react';

import { renderContentInAuthorMode, renderContent } from '../../../modules';

type WalletWidgetContainerBodyProps = {
  children?: ReactNode;
  cqItems?: object;
  isAuthorMode?: boolean;
  itemPath?: string;
  pagePath?: string;
  totalNumberOfCards: string[];
};

export const WalletWidgetContainerBody: FC<WalletWidgetContainerBodyProps> = memo(
  ({ children, cqItems, isAuthorMode, itemPath, pagePath, totalNumberOfCards }) => (
    <div className="wallet-widget-container__body" data-testid="wallet-widget-body">
      {isAuthorMode ? (
        totalNumberOfCards?.length ? (
          renderContentInAuthorMode({ totalNumberOfCards, pagePath, itemPath })
        ) : (
          <div className="wallet-widget-container__content-placeholder">
            <span>Drop components here (parsys not configured)</span>
          </div>
        )
      ) : (
        totalNumberOfCards?.map((cardName: string, index: number) =>
          renderContent({ cardName, jsonData: cqItems, index })
        )
      )}
      {children}
    </div>
  )
);

WalletWidgetContainerBody.displayName = 'WalletWidgetContainerBody';
